export default __webpack_public_path__ + "static/lifelong-learning-programmatori-cos'è-perché-Importante-d8aff72d69e371f11bd98e8aa4e62610.jpg";